/** "Change history": who changed which field of the campaign, from what to what, and when. */
import { CampaignHistoryBody, type CampaignHistoryBodyProps } from './CampaignHistoryBody';

export function CampaignHistoryCard(props: CampaignHistoryBodyProps) {
  return (
    <section className="nb-card" aria-labelledby="campaign-history-title" style={{ minWidth: 0 }}>
      <div className="nb-card-hd" style={{ marginBottom: 8 }}>
        <h3 id="campaign-history-title">Change history</h3>
      </div>
      <CampaignHistoryBody {...props} />
    </section>
  );
}
